import React from 'react';
import { makeStyles, MenuItem, Select } from '@material-ui/core';
import { setClassNameInDefns } from '../../common/definitionHelper';

const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        sortDropDown: {
            // border: '2px solid #000',
        },
        select: {
            paddingTop: '10px',
            paddingBottom: '10px',
            border: '2px solid #000',
            '&:focus': { borderColor: 'rgba(0, 0, 0, 0)' },
        },
    }));
};

const getDefns = params => {
    const { classes, props } = params;

    const { onChange } = props;

    const defns = {
        sortDropDown: {
            ...props,
            variant: 'outlined',
            // style: { paddingLeft: '10px' },
            classes: {
                select: classes.select,
            },
            color: 'secondary',
            fullWidth: true,
            defaultValue: '',
            onChange: e => onChange(e.target.value),
        },
    };

    // inject classes
    setClassNameInDefns(defns, classes);

    return defns;
};

const SortDropDown = props => {
    const classes = useStyles(/*{param1, param2}*/)();
    const defns = getDefns({ classes, props });
    const { options } = props;
    return (
        <Select {...defns.sortDropDown}>
            {options?.map(el => (
                <MenuItem value={el.value}>{el.label}</MenuItem>
            ))}
        </Select>
    );
};
export default SortDropDown;
